// extracted by mini-css-extract-plugin
module.exports = {"selectedAreaWrapper":"SelectedLessonTypeSummary2_selectedAreaWrapper__Y4Nk9","areaCard":"SelectedLessonTypeSummary2_areaCard__TVsB4"};